import React, { useState } from 'react';
import { useRouter } from 'next/router';

import './CourseListOverview.scss';
import Transition from '../Transition/Transition.jsx';
import icons from '../../shared/assets/icons/redesign';
import { trackAction, usePlatform } from '../../helpers/tracking';
import CoursesBuyPopup from '../CoursesBuyPopup/CoursesBuyPopup.jsx';
import { getActiveSubscriptions } from '../../helpers/user';

const { ChevronLeft, ChevronRight, Play, Lock } = icons;

export default function CourseListOverview({
  list = [],
  user,
  isInDepthCourse,
  hasAccess,
  userSubscriptions
}) {
  const router = useRouter();
  const platform = usePlatform();

  const [currentPage, togglePage] = useState(1);
  const [buyPopup, showBuyPopup] = useState(false);

  const page =
    router.pathname === '/zwangerschapscursus/overzicht'
      ? 'coursesoverzicht'
      : 'courseswelkom';

  const targetList = isInDepthCourse
    ? list
    : list
        .filter((course) =>
          getActiveSubscriptions(userSubscriptions).find(({ type }) =>
            type.includes(course.name)
          )
        )
        .sort((a, b) => (+a.prio > +b.prio ? 1 : -1));

  return (
    <>
      <Transition on={buyPopup && !isInDepthCourse}>
        <CoursesBuyPopup config={{}} showPopup={showBuyPopup} />
      </Transition>

      <ul className="courseListOverview">
        {targetList.map(
          ({
            name,
            displayName,
            courseModules,
            courseChapters,
            username,
            userImageUrl
          }) => (
            <li className="courseListOverview-course" key={name}>
              <div className="courseListOverview-course-header">
                {displayName}

                {!isInDepthCourse && (
                  <button
                    onClick={() => {
                      router.push(`/zwangerschapscursus/${name}`);

                      trackAction(platform, page, 'clickcourseoverview');
                    }}
                    className="courseListOverview-course-more-info-button"
                  >
                    Overzicht
                    <ChevronRight className="courseListOverview-course-more-info-icon" />
                  </button>
                )}
              </div>

              <div className="courseListOverview-course-module-list-wrap">
                <ul className="courseListOverview-course-module-list">
                  {[...courseChapters]
                    .sort((a, b) => (+a.prio >= +b.prio ? 1 : -1))
                    .reduce(
                      (list, chapter) => [
                        ...list,
                        ...[...chapter.courseModules].sort((a, b) =>
                          +a.prio >= +b.prio ? 1 : -1
                        )
                      ],
                      []
                    )
                    .map(
                      ({
                        imageUrl,
                        displayName,
                        position,
                        name: moduleName
                      }) => {
                        const courseAccessible =
                          (isInDepthCourse
                            ? hasAccess
                            : user.hasCourseAccess) || position === 'OPEN';

                        const courseModuleLink = isInDepthCourse
                          ? `/zwangerschapscursus/ouder-en-kind/${name}/${moduleName}`
                          : `/zwangerschapscursus/${name}/${moduleName}`;

                        return (
                          <li
                            key={moduleName}
                            onClick={() => {
                              courseAccessible
                                ? router.push(courseModuleLink)
                                : showBuyPopup(true);

                              trackAction(platform, page, 'clickcoursemodule');
                            }}
                            className="courseListOverview-course-module-list-item"
                          >
                            <img
                              className="courseListOverview-course-module-list-item-image"
                              src={imageUrl}
                              alt="course-image"
                            />

                            <button className="courseListOverview-play-button">
                              {courseAccessible ? (
                                <Play className="courseListOverview-play-button-icon" />
                              ) : (
                                <Lock className="courseListOverview-play-button-icon" />
                              )}
                            </button>

                            <div className="courseListOverview-course-module-list-item-info">
                              <p className="courseListOverview-course-module-name">
                                {displayName}
                              </p>

                              <img
                                className="courseListOverview-course-provider-logo"
                                src={userImageUrl}
                                alt="course-provider-image"
                              />
                              <span className="courseListOverview-course-provider-name">
                                {username}
                              </span>
                            </div>
                          </li>
                        );
                      }
                    )}
                </ul>

                <div>
                  {currentPage !== 1 && (
                    <div
                      className="courseListOverview-course-nav-button courseListOverview-course-prev-button"
                      onClick={(e) => {
                        move('backward', e);

                        trackAction(
                          platform,
                          page,
                          'clickpreviousmodulebutton'
                        );
                      }}
                    >
                      <ChevronLeft className="courseListOverview-course-nav-icon" />
                    </div>
                  )}

                  {currentPage !== courseModules.length && (
                    <div
                      className="courseListOverview-course-nav-button courseListOverview-course-next-button"
                      onClick={(e) => {
                        move('forward', e);

                        trackAction(platform, page, 'clicknextmodulebutton');
                      }}
                    >
                      <ChevronRight className="courseListOverview-course-nav-icon" />
                    </div>
                  )}
                </div>
              </div>
            </li>
          )
        )}
      </ul>
    </>
  );

  function move(direction, e) {
    const isForward = direction === 'forward';

    const translateX = `${
      isForward ? `-${currentPage}` : `-${currentPage - 2}`
    }00%`;

    const list = e.target
      .closest('.courseListOverview-course-module-list-wrap')
      .querySelector('.courseListOverview-course-module-list');

    list.style.cssText = `
      transition-duration: .3s;
      transform: translateX(${translateX});
      transition-property: transform;
    `;

    togglePage((previousPage) =>
      isForward ? previousPage + 1 : previousPage - 1
    );
  }
}
